import { createReducer, on } from '@ngrx/store';
import { OrganizationSupportReportsState } from '../../models/organizations/support.model';
import * as OrganizationsActions from '../../actions/organizations/support.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialOrganizationSupportReportsState: OrganizationSupportReportsState = {
  supportReportsByOrgId: {},
  currentSupportReport: undefined,
  supportReportTotalsByOrgId: {}
};

export const organizationSupportReportsReducer = createReducer(
  initialOrganizationSupportReportsState,

  on(OrganizationsActions.loadSupportReportsSuccess, (state, { organizationId, reports, total }) => ({
    ...state,
    supportReportsByOrgId: {
      ...state.supportReportsByOrgId,
      [organizationId]: reports
    },
    supportReportTotalsByOrgId: {
      ...state.supportReportTotalsByOrgId,
      [organizationId]: total as number
    }
  })),

  on(OrganizationsActions.loadSupportReportByIdSuccess, (state, { report }) => ({
    ...state,
    currentSupportReport: report
  })),

  on(OrganizationsActions.createSupportReportSuccess, (state, { organizationId, report }) => {
    const prev = state.supportReportsByOrgId?.[organizationId] || [];
    const prevTotal = state.supportReportTotalsByOrgId?.[organizationId] || 0;
    
    return {
      ...state,
      supportReportsByOrgId: {
        ...state.supportReportsByOrgId,
        [organizationId]: [report, ...prev]
      },
      currentSupportReport: report,
      supportReportTotalsByOrgId: {
        ...state.supportReportTotalsByOrgId,
        [organizationId]: (prevTotal as number) + 1
      }
    };
  }),

  on(OrganizationsActions.updateSupportReportSuccess, (state, { organizationId, report }) => {
    const prev = state.supportReportsByOrgId?.[organizationId] || [];
    
    return {
      ...state,
      supportReportsByOrgId: {
        ...state.supportReportsByOrgId,
        [organizationId]: prev.map(r => r.data.id === report.data.id ? report : r)
      },
      currentSupportReport: state.currentSupportReport?.data.id === report.data.id ? report : state.currentSupportReport
    };
  }),

  on(OrganizationsActions.deleteSupportReportSuccess, (state, { organizationId, reportId }) => {
    const previous = state.supportReportsByOrgId?.[organizationId] || [];
    const wasListed = previous.some(report => report.data.id === reportId);
    const currentMatches = state.currentSupportReport?.data.id === reportId &&
      state.currentSupportReport?.data.organizationId === organizationId;
    return {
      ...state,
      supportReportsByOrgId: {
        ...state.supportReportsByOrgId,
        [organizationId]: previous.filter(report => report.data.id !== reportId)
      },
      supportReportTotalsByOrgId: {
        ...state.supportReportTotalsByOrgId,
        [organizationId]: Math.max(0,
          (state.supportReportTotalsByOrgId?.[organizationId] || 0) - (wasListed || currentMatches ? 1 : 0))
      },
      currentSupportReport: currentMatches ? undefined : state.currentSupportReport
    };
  }),

  // Reset organization support reports state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialOrganizationSupportReportsState)
);
